module.exports = __webpack_public_path__ + "static/img/227_TO8_1968.720170c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/227_TO8_1968.jpg
// module id = ha8S
// module chunks = 0